export default "<button *ngIf=\"caption != ''\" class=\"btn btn-primary btn-sm mr-1 mb-1\" disabled>{{ caption }}</button>\r\n";